module.exports = __webpack_public_path__ + "static/media/listing-page-srinagar.c7a74476.webp";